module.exports = __webpack_public_path__ + "static/img/bg1.91a43ee.png";